import {RubricaService} from '../../../../../services/rubrica.service';
import {CountryCodesService} from '../../../../../services/data/country-codes.service';
import {AlertService} from '../../../../../services/ui/alert.service';
import {FormService} from '../../../../../services/ui/form.service';
import {ArchiSmallERRORS} from '../../../../../commons/errors';
import {ModalitaPagamentoService} from '../../../../../services/data/modalita-pagamento.service';

export const RubricaInsertPRModalComponent = {
  template: require('./rubrica-insert-pr-modal.html'),
  controller: class RubricaInsertPRModalComponent {

    static $inject: string[] = [
      'RubricaService',
      'AlertService',
      'FormService',
      'CountryCodesService',
      'ModalitaPagamentoService'

    ];

    private item: any;
    private countryCodes: Record<string, string>;
    private modalitaPagamentoTypes: Record<string, string>;
    private regimeFiscaleType: Record<string, string>;

    private validPIVA: boolean;
    private validCF: boolean;
    private validPEC: boolean;

    private ProvinciaType = new RegExp('^[A-Z]{2}$');
    private PIVAType = new RegExp('^[A-Z0-9]{1,28}$');
    private CodiceFiscaleType = new RegExp('^[A-Z0-9]{11,16}$');
    private CAPType = new RegExp('^[0-9]{5}$');
    private CodiceDestinatarioType = new RegExp('^[A-Z0-9]{7}$');
    private IBANType = new RegExp('^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{23,30}$');

    private close: any;

    constructor(
      private rubricaService: RubricaService,
      private alertService: AlertService,
      private formService: FormService,
      countryCodesService: CountryCodesService,
      modalitaPagamentoService: ModalitaPagamentoService
    ) {
      this.formService.resetFormSubmitted();

      this.item = {
        'email_pec': '',
        'emails': [],
        'company_name': '',
        'fiscal_code': '',
        'id_paese': 'IT',
        'piva': '',
        'cap': '',
        'indirizzo': '',
        'codice_destinatario': '',
        'iban': '',
        'nome': '',
        'cognome': '',
        'comune': '',
        'provincia': '',
        'id_nazione': 'IT',
        'type': '',
        'payment_mode': 'MP05',
        'regime_fiscale': 'RF01'
      };

      this.countryCodes = countryCodesService.getCountryCodes();
      this.modalitaPagamentoTypes = modalitaPagamentoService.getTypes();
      this.regimeFiscaleType = {
        'RF01': 'Regime ordinario',
        'RF02': 'Regime dei contribuenti minimi (art. 1,c.96-117, L. 244/2007)',
        'RF04': 'Agricoltura e attività connesse e pesca (artt. 34 e 34-bis, D.P.R. 633/1972)',
        'RF05': 'Vendita sali e tabacchi (art. 74, c.1, D.P.R. 633/1972)',
        'RF06': 'Commercio dei fiammiferi (art. 74, c.1, D.P.R. 633/1972)',
        'RF07': 'Editoria (art. 74, c.1, D.P.R. 633/1972)',
        'RF08': 'Gestione di servizi di telefonia pubblica (art. 74, c.1, D.P.R. 633/1972)',
        'RF09': 'Rivendita di documenti di trasporto pubblico e di sosta (art. 74, c.1, D.P.R. 633/1972)',
        'RF10': 'Intrattenimenti, giochi e altre attività di cui alla tariffa allegata al D.P.R. 640/72 (art. 74, c.6, D.P.R. 633/1972)',
        'RF11': 'Agenzie di viaggi e turismo (art. 74-ter, D.P.R. 633/1972)',
        'RF12': 'Agriturismo (art. 5, c.2, L. 413/1991)',
        'RF13': 'Vendite a domicilio (art. 25-bis, c.6, D.P.R. 600/1973)',
        'RF14': 'Rivendita di beni usati, di oggetti d’arte, d’antiquariato o da collezione (art. 36, D.L. 41/1995)',
        'RF15': 'Agenzie di vendite all’asta di oggetti d’arte, antiquariato o da collezione (art. 40-bis, D.L. 41/1995)',
        'RF16': 'IVA per cassa P.A. (art. 6, c.5, D.P.R. 633/1972)',
        'RF17': 'IVA per cassa (art. 32-bis, D.L. 83/2012)',
        'RF18': 'Altro',
        'RF19': 'Regime forfettario',
        'RF20': 'Regime transfrontaliero di Franchigia IVA (Direttiva UE 2020/285)'
      };

      this.validPIVA = true;
      this.validCF = true;
      this.validPEC = true;
    }

    emptyAziendaFields() {
      this.item.company_name = '';
    }

    emptyPrivatoFields() {
      this.item.nome = '';
      this.item.cognome = '';
    }

    insert = () => {
      this.rubricaService.insert(this.item)
        .then((response) => {
          this.save(response);
        }, (error) => {
          this.alertService.alert('error', error);
        });
    };

    cancel() {
      this.close();
    }

    validatePiva(item: any) {
      if (item.piva === null || item.piva === undefined || item.piva === '') {
        this.validPIVA = true;
        return;
      }

      this.rubricaService.validatePivaAndCF(item.piva, item.fiscal_code, item._id === undefined ? 0 : item._id)
        .then((response: any) => {
          this.validPIVA = response === 'true';
        }, (error) => {
          this.alertService.alert('error', error);
        });
    }

    validateCF(item: any) {
      if (item.fiscal_code === null || item.fiscal_code === undefined || item.fiscal_code === '') {
        this.validCF = true;
        return;
      }

      this.rubricaService.validateCF(item.fiscal_code, item._id === undefined ? 0 : item._id)
        .then((response: any) => {
          this.validCF = response === 'true';
        }, (error) => {
          this.alertService.alert('error', error);
        });

      this.rubricaService.validatePivaAndCF(item.piva, item.fiscal_code, item._id === undefined ? 0 : item._id)
        .then((response: any) => {
          this.validPIVA = response === 'true';
        }, (error) => {
          this.alertService.alert('error', error);
        });
    }

    validatePEC(item: any) {
      if (item.email_pec === null || item.email_pec === undefined || item.email_pec === '') {
        this.validPEC = true;
        return;
      }

      this.rubricaService.validateEmail(item)
        .then((response: any) => {
          this.validPEC = response === 'true';
        }, (error) => {
          if (this.isEmailAlreadyUsed(error)) {
            this.validPEC = false;
          } else {
            this.alertService.alert('error', error);
          }
        });
    }

    onChangeNazione(): void {
      if (this.item.id_nazione !== 'IT') {
        this.item.codice_destinatario = 'XXXXXXX';
      } else {
        this.item.codice_destinatario = '';
      }
    }

    isFormSubmitted(): boolean {
      return this.formService.isFormSubmitted();
    }

    private save(item: any) {
      this.close({$value: item});
    }

    private isEmailAlreadyUsed(error: any): boolean {
      return error &&
        error.data &&
        error.data.errorCode === ArchiSmallERRORS.ANAGRAFICA_EMAIL_ALREADY_USED;
    }
  },
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pr/rubrica-insert-pr-modal/rubrica-insert-pr-modal.ts